<template>
    <div class="md:w-1/2 xl:w-1/4 px-4 py-2">
        <div class="flex flex-col align-center rounded oveflow-hidden shadow-lg p-3 bg-cryma h-full">
            <div class="flex-auto px-6 py-4">
                <div class="font-extrabold text-xl md:text-3xl mb-6">
                    <a :href="url">
                        <slot name="title"></slot>
                    </a>
                </div>
                <p class="text-black text-base md:text-lg">
                    <slot name="body"></slot>
                </p>
            </div>
            <div class="px-4 py-4">
                <slot name="hashtags"></slot>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['url']
}
</script>
